import { useQuery } from '@tanstack/react-query';
import { getLatestSearchesCountOptions } from './latest-searches-count';

export const useLatestSearchesCount = () =>
  useQuery(getLatestSearchesCountOptions());
